export const footerData = [
  {
    label: '藍十字概況',
    value: '1',
    children: [
      {
        value: '1-1',
        label: '關於我們',
        href: '/ch/AboutBlueCross/Information/CompanyProfile',
      },
      {
        value: '1-2',
        label: '新聞中心',
        href: '/ch/AboutBlueCross/Information/NewsRoom',
      },
      {
        value: '1-3',
        label: '獎項殊榮',
        href: '/ch/AboutBlueCross/Information/CompanyAwards',
      },
      {
        value: '1-4',
        label: '社會企業責任',
        href: '/ch/AboutBlueCross/Information/SocialResponsibility',
      },
      {
        value: '1-5',
        label: '工作機會',
        href: '/ch/career-opportunities/Information',
      },
    ],
  },
  {
    label: '網誌',
    value: '3',
    children: [
      {
        value: '3-1',
        label: '所有主題',
        href: 'https://just-right.bluecross.com.hk/blog/all',
        target: '_blank',
      },
      {
        value: '3-2',
        label: '健康智識',
        href: 'https://just-right.bluecross.com.hk/blog/health',
        target: '_blank',
      },
      {
        value: '3-3',
        label: '智式生活',
        href: 'https://just-right.bluecross.com.hk/blog/life',
        target: '_blank',
      },
      {
        value: '3-4',
        label: '智寵您',
        href: 'https://just-right.bluecross.com.hk/blog/pet',
        target: '_blank',
      },
      {
        value: '3-5',
        label: '智遊天下',
        href: 'https://just-right.bluecross.com.hk/blog/travel',
        target: '_blank',
      },
      {
        value: '3-6',
        label: '保障啱啱好',
        href: 'https://just-right.bluecross.com.hk/blog/protection',
        target: '_blank',
      },
    ],
  },
  {
    label: '聯絡我們',
    value: '2',
    children: [
      {
        value: '2-1',
        label: '電話：(852) 2839 6333',
        icon: 'mobile',
        href: 'tel:+85228396333',
      },
      {
        value: '2-2',
        icon: 'email',
        label: '電郵：cs@bluecross.com.hk',
        href: 'mailto:cs@bluecross.com.hk',
      },
      {
        value: '2-3',
        icon: 'fax',
        label: '傳真：(852) 2263 7517',
      },
      {
        value: '2-4',
        icon: 'customer-service',
        label: '客戶服務中心',
        children: [
          {
            label: '星期一至星期五',
          },
          {
            label: '上午9時至下午5時30分',
          },
          {
            label: '星期六、日及公眾假期休息',
          },
        ],
      },
      {
        value: '2-5',
        icon: 'location',
        label: '地址:',
        children: [
          {
            label: '香港灣仔皇后大道東183號合和中心54樓',
          },
        ],
      },
    ],
  },

  {
    label: '給我們意見',
    value: '5',
    children: [
      {
        value: '5-1',
        label: '意見 / 查詢',
        icon: 'conversation',
        href: '/ch/Contact-Us/Online-Enquiry',
      },
      {
        value: '5-2',
        label: '下載Blue Cross HK App',
        children: [
          {
            value: '5-2-1',
            href: 'https://play.google.com/store/apps/details?id=hk.com.bluecross.mobileapp',
            target: '_blank',
            type: 'GooglePlay',
            icon: '/images/CorporateWebsite/Icon/googleplay.png',
          },
          {
            value: '5-2-2',
            href: 'https://apps.apple.com/hk/app/blue-cross-hk/id1441274976',
            target: '_blank',
            type: 'AppStore',
            icon: '/images/CorporateWebsite/Icon/appstore.png',
          },
        ],
      },
    ],
  },
  {
    label: '法律聲明',
    value: '6',
    children: [
      {
        value: '6-1',
        label: '免責聲明',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/Disclaimer/ch',
      },
      {
        value: '6-3',
        label: '保險業監管局保費徵費',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/levy_collection/ch',
      },
      {
        value: '6-4',
        label: '收集個人資料聲明',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/pics_bcaia/ch',
      },
      {
        value: '6-5',
        label: '私隱政策聲明',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/eprivacy/ch',
      },
    ],
  },
];

export const mediaData = [
  {
    value: '1',
    href: 'https://www.facebook.com/BlueCrossHK/',
    icon: 'facebook',
    target: '_blank',
  },
  {
    value: '2',
    href: 'https://www.instagram.com/bluecrosshk',
    icon: 'instagram',
    target: '_blank',
  },
  {
    value: '3',
    href: 'https://www.youtube.com/channel/UC6_r0jCRF9iMXod58WwQYzQ',
    icon: 'youtube',
    target: '_blank',
  },
  {
    value: '4',
    href: 'https://www.linkedin.com/company/blue-cross-asia-pacific-insurance-limited',
    icon: 'linkedin',
    target: '_blank',
  },
];

export const mobileStoreData = [
  {
    value: '1',
    href: 'https://play.google.com/store/apps/details?id=hk.com.bluecross.mobileapp',
    target: '_blank',
    type: 'GooglePlay',
    icon: '/images/CorporateWebsite/Icon/googleplay.png',
  },
  {
    value: '2',
    href: 'https://apps.apple.com/hk/app/blue-cross-hk/id1441274976',
    target: '_blank',
    type: 'AppStore',
    icon: '/images/CorporateWebsite/Icon/appstore.png',
  },
];
